import { Entity, Field } from 'typegraph';

import Subscription from './Subscription';
import User from './User';

@Entity({one: "userSummaryUser", many: "userSummariesUser"})
export default class UserSummary {

	@Field({entity: User})
	public user?: User;

	@Field()
	public certificatesCount?: number;

	@Field({entity: Subscription})
	public lastLaunched?: Subscription;

	@Field()
	public avatarURL?: string;

}



// WEBPACK FOOTER //
// ./src/panels/userSummary/entities/UserSummary.ts